module.exports = __webpack_public_path__ + "img/logo_dietz.d38dbefa.png";